module.exports = ($scope, $uibModalInstance, $http, $log, $analytics, endpoints, name, languages) ->
  $scope.translating = false
  $scope.languages = languages
  $scope.from_languages = [{ id: '', name: 'Automatically detect'}].concat(languages)
  $scope.query = name
  $scope.translated_from_language = $scope.from_languages[0]
  $scope.translated_to_language = { id: 0 }


  $scope.languagesLookup = {}
  for language in languages
    $scope.languagesLookup[language.id] = language

  $scope.doTranslation = ->
    if $scope.query and $scope.translated_to_language.id and $scope.query.length > 0
      if $scope.translated_to_language.id == $scope.translated_from_language.id
        $scope.translated_query = $scope.query
        return

      translated_from_language = $scope.languagesLookup[$scope.translated_from_language.id]
      translated_to_language = $scope.languagesLookup[$scope.translated_to_language.id]

      $scope.translating = true
      $http.get endpoints.Translate
      ,
        params:
          to: translated_to_language?.iso_code or ''
          from: translated_from_language?.iso_code or ''
          text: $scope.query
          is_query: true
      .success (data, status, headers, config) ->
        $scope.translated_query = data.translated_text
        $scope.translating = false

    else
      $log.debug "No target language, therefore no translation."

    return

  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.ok = ->
    $uibModalInstance.close $scope.translated_query
    return
